export default __webpack_public_path__ + "static/media/logo_red.ba646220.png";